/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var labelTextStyles = css({
  alignSelf: 'center',
  gridArea: '1 / 2 / 2 / 3'
});
export default function LabelText(_ref) {
  var children = _ref.children;
  return jsx("span", {
    css: labelTextStyles
  }, children);
}